module.exports = __webpack_public_path__ + "static/media/Spanish_European_Pilar_BG-53.649b27a6.png";